module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/58.f8ee23f1.png";